module.exports = __webpack_public_path__ + "img/p3.3290e377.jpg";